import { render, staticRenderFns } from "./AlFormRadio.vue?vue&type=template&id=a8f9e4f2&"
import script from "./AlFormRadio.vue?vue&type=script&lang=js&"
export * from "./AlFormRadio.vue?vue&type=script&lang=js&"
import style0 from "./AlFormRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports